import AgrActionTypes from './AgrActionTypes';
import AgrDispatcher from './AgrDispatcher';
import Server from './Server'
import Utils from '../Utils'

const server = new Server()

const Actions = {

  checkHash() {
    var params = Utils.hashToMap()

    if (params.user) {
      Actions.onLogin({token: params.user})
      Actions.loadAgreements()
    }

    AgrDispatcher.dispatch({type: AgrActionTypes.CHANNEL, data: params})
  },

  signAgreement(agreement, agree) {
    AgrDispatcher.dispatch({type: AgrActionTypes.AGREEMENT_SAVING, data: true})
    server.signAgreement(Actions.loginInfo.token, agreement, agree, () => {

      Actions.loadAgreements(() => {
        AgrDispatcher.dispatch({type: AgrActionTypes.AGREEMENT_SAVING, data: false})
      })
    }, (err) => {
      Actions.backToApp()
    })
  },

  selectAgreement(agreement) {
    AgrDispatcher.dispatch(
      {type: AgrActionTypes.AGREEMENT_SELECTED, data: agreement}
    )
  },

  backToApp() {
    if (window.androidCallback && window.androidCallback.goBackToApp) {
      // Android callback
      window.androidCallback.goBackToApp()
    } else {
      // iOS callback
      window.location.href = "webCallBack://?task=goBackToApp";
    }
  },

  loadAgreementsLang(params, callback, error) {
    server.getAgreements(Actions.loginInfo.token, params, callback, error)
  },

  loadAgreements(mainCallback) {
    var params = Utils.hashToMap()
    var callback = (agreements) => {
      AgrDispatcher.dispatch(
        {type: AgrActionTypes.AGREEMENTS_LOADED, data: agreements}
      )
      if (mainCallback) {
        mainCallback()
      }
    }

    this.loadAgreementsLang(params, callback, (err) => {
      if (err.statusText === "Unauthorized") {
        if (params.channel && params.channel.indexOf("_app") !== -1) {
          Actions.backToApp()
        } else {
          Actions.logout()
        }
      } else if (err.status === 500) {
        if (params.lang !== 'en') {
          params.lang = 'en'
          this.loadAgreementsLang(params, callback, (err) => {
            Actions.backToApp()
          })
        } else {
          Actions.backToApp()
        }
      }
    })
  },

  loginStart() {
    AgrDispatcher.dispatch({type: AgrActionTypes.LOGIN_START})
  },

  onLogin(loginResponse) {
    AgrDispatcher.dispatch({type: AgrActionTypes.LOGGED_IN, data: loginResponse})

    Actions.loginInfo = loginResponse
    Actions.loadAgreements()
  },

  logout() {
    Actions.loginInfo = null

    AgrDispatcher.dispatch({type: AgrActionTypes.LOGOUT})
  },

  login(loginInfo) {
    Actions.loginStart()

    server.login(loginInfo.username, loginInfo.password, (loginResponse) => {
      Actions.onLogin(loginResponse)
    }, (err) => {
      AgrDispatcher.dispatch({
        type: AgrActionTypes.LOGIN_FAILED,
        data: {
          message: "app.login.error.email",
          params: {
            email: loginInfo.username
          },
          action: () => {
            Actions.sendPasswordReset(loginInfo.username)
          },
          actionLabel: "app.login.reset.send"
        }
      })
    })
  },

  loginGoogle(resp) {
    Actions.loginStart()
    server.loginGoogle(resp.accessToken, (loginResponse) => {
      Actions.onLogin(loginResponse)
    }, (err) => {
      Actions.loginFailed()
    })
  },

  loginFacebook(token) {
    Actions.loginStart()
    server.loginFacebook(token, (loginResponse) => {
      Actions.onLogin(loginResponse)
    }, (err) => {
      Actions.loginFailed()
    })
  },

  loginFailed() {
    AgrDispatcher.dispatch({
      type: AgrActionTypes.LOGIN_FAILED,
      data: {
        message: "app.login.error",
        action: Actions.clearMessage,
        actionLabel: "app.login.dismiss"
      }
    })
  },

  sendPasswordReset(email) {
    AgrDispatcher.dispatch({type: AgrActionTypes.CLEAR_ERROR})
    server.reset(email, (resp) => {
      if (resp.success) {
        AgrDispatcher.dispatch({
          type: AgrActionTypes.RESET_SENT,
          data: {
            message: "app.login.reset.sent",
            params: {
              email: email
            },
            action: Actions.clearMessage,
            actionLabel: "app.login.dismiss"
          }
        })
      } else {
        AgrDispatcher.dispatch({
          type: AgrActionTypes.RESET_FAILED,
          data: {
            message: "app.login.reset.sendError",
            params: {
              email: email
            },
            action: Actions.clearMessage,
            actionLabel: "app.login.dismiss"
          }
        })
      }
    }, (err) => {
      AgrDispatcher.dispatch({
        type: AgrActionTypes.RESET_FAILED,
        data: {
          message: "app.login.reset.sendError",
          params: {
            email: email
          },
          action: Actions.clearMessage,
          actionLabel: "app.login.dismiss"
        }
      })
    })
  },

  clearMessage() {
    AgrDispatcher.dispatch({type: AgrActionTypes.CLEAR_ERROR})
  },

  onGoogleLoginResponse(resp) {
    Actions.loginGoogle(resp)
  },

  onGoogleLoginFail() {
    Actions.loginFailed()
  },

  onFacebookLoginResponse(userData) {
    if (userData != null) {
      Actions.loginFacebook(userData.tokenDetail.accessToken)
    } else {
      Actions.loginFailed()
    }
  },

  onFacebookLoginError(error) {
    Actions.loginFailed()
  }
}

export default Actions;



// WEBPACK FOOTER //
// ./src/data/AgrActions.js